// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LB8Hn5sDqFbSyfXq\\+-S4Ow\\=\\= {\n    margin: auto;\n    width: 100%;\n}\n\n.a1kbYlhTwx82X2EQxjGTkQ\\=\\= {\n    text-align: center;\n}", "",{"version":3,"sources":["webpack://./src/shared/styles/Page404.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".gridContainer {\n    margin: auto;\n    width: 100%;\n}\n\n.gridItem {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": "LB8Hn5sDqFbSyfXq+-S4Ow==",
	"gridItem": "a1kbYlhTwx82X2EQxjGTkQ=="
};
export default ___CSS_LOADER_EXPORT___;
